import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { resolve } from 'url';
import { reject } from 'q';
import { FormGroup } from '@angular/forms';
import { IOption } from 'ng-select';

@Injectable()
export class HelperService {

  constructor(private sanitizer: DomSanitizer) { }

  capitalize(text: String) {
    if (text === null || text.trim() === '') {
      return '';
    }

    return text.replace(/\w\S*/g, txt => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  capitalizeFirstLetter(text: String) {
    if (text === null || text.trim() === '') {
      return '';
    }

    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  datePickerLocale() {
    const loc = {
      monday: true,
      weekdays: ['Lun.', 'Mar.', 'Mie.', 'Jue.', 'Vie.', 'Sab.', 'Dom.'],
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    };
    return loc;
  }

  download(stream:string, fileName:string){
    return new Promise((resolve, reject) => {
      
      let ext = (((stream.split(",")[0]).split(":")[1]).split("/")[1]).split(";")[0];
      let a = document.createElement("a");
      a.href = stream
      a.download=`${fileName}.${ext}`;
      a.click();

    })


  }

  setCustomErrorMessages(messages: any, form: FormGroup) {
    (<any>form)._customErrors = messages;
  }

  getCustomErrorMessages(form: FormGroup) {
    return (<any>form)._customErrors;
  }

  createSelect(list: Array<any>): Array<IOption>{
    const lisTemp: Array<IOption> = list.map((item) => {
      return {
        value: item.id,
        label:  item.name,
        data: item
      };
    });

    return lisTemp;
  }

  getTrueORFalse(key: any): boolean {
    if ( key === 'Y' || key === 1) {
      return true;
    }

    if(key === 'N' || key === 0){
      return false;
    }
  }

  getYesORNot(key: any): String {
    if ( key || key === 1) {
      return 'Y';
    }

    if (!key || key === 0) {
      return 'N';
    }
  }

  cleanJson(obj) {
    const json = Object.assign({}, obj)
    for (var propName in json) { 
      if (json[propName] === null || json[propName] === undefined || json[propName] === "") {
        delete json[propName];
      }
    }
    return json;
  }

  public checkValidators(form, controlName, validators?) {
    if (validators) {
      form.get(`${controlName}`).setValidators(validators);
    } else {
      form.get(`${controlName}`).clearValidators();
    }
    form.updateValueAndValidity();
  }


  getYesORNotNum(key: any): String {
    if ( key || key === 1) {
      return '1';
    }

    if (!key || key === 0) {
      return '0';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/helper.service.ts